import { connect } from 'react-redux';
import { Creators } from '../../../services/redux/object/actions';
import GetObjectDetails from './components';
import { getFormValues } from 'redux-form';
import { change } from 'redux-form';

const mapStateToProps = state => {
  const { object, boat_types, jetty_types, drive_types, isloading, error, error_message, selectedObjectType, selectedObjectName } = state.object;
  return {
    object,
    boat_types, 
    jetty_types, 
    drive_types,
    isloading,
    error,
    error_message,
    initialValues: state.object.object,
    firstOptionFormValues: getFormValues('boat-option-one')(state),
    secondOptionFormValues: getFormValues('boat-option-two')(state),
    thirdOptionFormValues: getFormValues('boat-option-three')(state),
    selectedObjectType,
    selectedObjectName,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchObject: (object_id) => {
      dispatch(Creators.fetchObject(object_id));
    },
    fetchBoatTypes: () => {
      dispatch(Creators.fetchBoatTypes());
    },
    fetchJettyTypes: () => {
      dispatch(Creators.fetchJettyTypes());
    },
    fetchDriveTypes: () => {
      dispatch(Creators.fetchDriveTypes());
    },
    saveObject: (data) => {
      dispatch(Creators.saveObject(data));
    },
    changeSizeField: (formName, product) => {
      dispatch(change(formName, 'object_square_m', product));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GetObjectDetails);

